export default __webpack_public_path__ + "static/media/eb-ultra-pro-4.72b8c2d1.png";